import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import FullPageSpinner from '../components/FullPageSpinner';
import { useApiContext } from '../contexts/apiContext';
import { useCurrentUser } from '../utils/user';

const SubscriptionsCheckoutRedirectPage: React.FC = () => {
  const { api } = useApiContext();
  const [queryParams] = useSearchParams();
  const { user } = useCurrentUser();

  const { priceId } = useParams<{ priceId: string }>();
  const quantity = Number(queryParams.get('quantity') || '1');
  const teamSlug = user?.default_team?.slug;

  useEffect(() => {
    if (priceId && teamSlug) {
      api()
        .subscriptions.createCheckoutSession({
          teamSlug,
          createCheckoutRequest: { priceId, quantity },
        })
        .then((res) => {
          // Redirect to the freshly obtained Stripe checkout session link
          window.location.href = res.data;
        });
    }
  }, [priceId, teamSlug]);

  return <FullPageSpinner />;
};

export default SubscriptionsCheckoutRedirectPage;
